// Copyright (c) 2019 Deere & Company

import actions from '../../actions-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_TCSM_AUDIT_CONFIRMATION_MODAL
});

export const setConfirmationModal = options => ({
    data: options,
    type: actions.SET_TCSM_AUDIT_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/confirmation-modal.js